export const ROLES = {
  INTERNAL_ADMIN: "internal-admin",
  CLIENT_MANAGER: "client-manager",
  CLIENT_TRAINEE: "client-trainee",
  CONVERSATION_REVIEWER: "conversation-reviewer",
  USER_ADMIN: "user-admin",
  COURSE_AUTHOR: "course-author",
} as const;

export type Role = (typeof ROLES)[keyof typeof ROLES];
